'use strict';

const base = require('base/product/base');
const detail = require('base/product/detail');
const {encodeHtml} = require('sswd_base/util/XStringUtils');
const Swiper = require('../thirdParty/swiper');
const {scroll} = require('app_common/client/clientScrollUtils');

/**
 * 変動スピード
 *
 * @protected
 * @constant {number}
 */
const SPIN_SPEED = 20;

/**
 * スピナーコントロール用配列
 * グローバルに使用するため定義
 */
let arySpinnerCtrl = [];

/**
 * 変動計算する関数。
 * スピナー値の最大値や最小値を超えないように制御
 *
 */
function spinnerCal() {
    let target = $(arySpinnerCtrl['.target']);
    // 現在の値を取得
    let num = Number(target.val());
    // 数量を加算
    num += arySpinnerCtrl['.cal'];
    if (num > Number(target.data('max'))) {
        // 最大値を超える場合、最大値をセット
        target.val(Number(target.data('max')));
    } else if (Number(target.data('min')) > num) {
        // 最大値を超える場合、最大値をセット
        target.val(Number(target.data('min')));
    } else {
        target.val(num);
    }
}

/**
 * 数量変更スピナー
 */
function quantityChange() {
    // 数量変更ボタン長押し時
    $('.btnspinner').on('touchstart mousedown click', function (e) {
        if (arySpinnerCtrl['.interval']) return false;
        // 入力フィールドを示すオブジェクトを取得
        let target = $(this).data('target');
        arySpinnerCtrl['.target'] = target;
        arySpinnerCtrl['.timestamp'] = e.timeStamp;
        // 数量の増減値を格納
        arySpinnerCtrl['.cal'] = Number($(this).data('cal'));

        // クリックは単一の処理に留める
        if (e.type === 'click') {
            spinnerCal(arySpinnerCtrl);
            arySpinnerCtrl = [];
            return false;
        }

        // 長押し時の処理
        setTimeout(function () {
            // インターバル未実行中 + 長押しのイベントタイプスタンプ一致時に計算処理
            // 長押しから500ミリ秒後に処理が実行される
            if (!arySpinnerCtrl['.interval'] && arySpinnerCtrl['.timestamp'] === e.timeStamp) {
                arySpinnerCtrl['.interval'] = setInterval(spinnerCal, SPIN_SPEED);
            }
        }, 500);
    });

    // 長押し解除時 画面スクロールも解除に含む
    $(document).on('touchend mouseup scroll', function (e) {
        if (arySpinnerCtrl['.interval']) {
            // スピナーの変動を停止するために値をクリア
            clearInterval(arySpinnerCtrl['.interval']);
            arySpinnerCtrl = [];
        }
    });
    $('.quantity-select').on('change', function (e) {
        const quantity = parseInt($(this).val());
        if (isNaN(quantity) || quantity <= 0) {
            $(this).val(1);
        }
    });
}

/**
 * 構成品選択時のモーダル実行
 */
function clickAssortedProducts() {
    $('#requestProductDetailsModal').on('show.bs.modal', function (event) {
        // モーダルを呼び出すときに使われたボタンを取得
        let link = $(event.relatedTarget);

        // モーダルを取得
        let modal = $(this);

        // 取得した構成品情報で上書きする
        modal.find('#modal-title').text(link.data('name'));
        modal.find('#modal-img').attr('src', link.data('imageurl'));
        modal.find('#modal-img').attr('alt', link.data('imagealt'));
        modal.find('#modal-img').attr('title', link.data('imagetitle'));
        modal.find('#modal-description').text(link.data('description'));

        // 初期化
        modal.find('#modal-storagedays').show();
        modal.find('#modal-label-storagedays').show();
        modal.find('#modal-internalCapacity').show();
        modal.find('#modal-label-internalCapacity').show();
        modal.find('#modal-allergies').show();
        modal.find('#modal-label-allergies').show();
        modal.find('#modal-nutritionalContents').show();
        modal.find('#modal-label-nutritionalContents').show();

        // 値がないものを項目ごと表示しない
        if (link.data('storagedays') !== null) {
            modal.find('#modal-storagedays').text('');
            modal
                .find('#modal-storagedays')
                .text(link.data('storagedays') + modal.find('#modal-storagedays').text());
        } else {
            modal.find('#modal-storagedays').hide();
            modal.find('#modal-label-storagedays').hide();
        }
        if (link.data('internalcapacity') !== '') {
            modal.find('#modal-internalCapacity').text(link.data('internalcapacity'));
        } else {
            modal.find('#modal-internalCapacity').hide();
            modal.find('#modal-label-internalCapacity').hide();
        }
        if (link.data('strjoinallergies') !== '') {
            modal.find('#modal-allergies').text(link.data('strjoinallergies'));
        } else {
            modal.find('#modal-allergies').hide();
            modal.find('#modal-label-allergies').hide();
        }
        if (link.data('nutritionalcontents') !== '') {
            modal.find('#modal-nutritionalContents').html(link.data('nutritionalcontents'));
            modal.find('#modal-nutritionalContents').css('white-space', 'pre-line');
        } else {
            modal.find('#modal-nutritionalContents').hide();
            modal.find('#modal-label-nutritionalContents').hide();
        }
    });
}

/**
 * 日付をYYYY/MM/DD形式で返却します
 * @param {date} dt 日付
 * @returns {string} YYYY/MM/DD日付
 */
function formatDate(dt) {
    let y = dt.getFullYear();
    let m = ('00' + (dt.getMonth() + 1)).slice(-2);
    let d = ('00' + dt.getDate()).slice(-2);
    return y + '/' + m + '/' + d;
}
/**
 * エラーメッセージを表示するポップアップを作成する
 * @param {Object} message - エラーメッセージ
 */
function createErrorNotification(message) {
    const errorHtml =
        '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
        'fade show" role="alert">' +
        '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
        '<span aria-hidden="true">&times;</span>' +
        '</button>' +
        encodeHtml(message) +
        '</div>';

    // カートメッセージのCSSを利用
    $('body').append('<div class="add-to-cart-messages"></div>');
    $('.add-to-cart-messages').append(errorHtml);
    setTimeout(function () {
        $('.add-to-cart-messages').remove();
    }, 5e3);
}

/**
 * 出荷予定日情報をDateTimePickerに設定します。
 * @param {object} apiData 出荷予定日情報
 * @returns エラーの場合はpopアップ表示を行い終了
 */
function dateTimePickerFunc(apiData) {
    // 出荷予定日カレンダー情報の取得
    let shippingDateList = apiData.data.shipping_date_list;

    // 　○：50%未満
    // 　△：50%以上
    // 　×：100%
    // 　-（グレーアウト）：空白（値無し）

    let sd = null;
    let ed = null;
    let checkMap = new Map();
    for (let i = 0; i < shippingDateList.length; i += 1) {
        // 選択可能開始日付の判定
        if (sd === null && shippingDateList[i].shipping_rate !== '') {
            sd = shippingDateList[i];
        }
        // 選択可能終了日付の判定
        if (shippingDateList[i].shipping_rate !== '') {
            ed = shippingDateList[i];
        }
        // 〇△×判定用
        checkMap.set(shippingDateList[i].shipping_date, shippingDateList[i].shipping_rate);
    }

    // 選択可能開始日・終了日が存在しない場合、
    if (sd === null) {
        sd = shippingDateList[0];
    }
    if (ed === null) {
        ed = shippingDateList[shippingDateList.length - 1];
    }

    // dataPickerの設定
    $('#shipping-date').datepicker({
        language: 'ja', // 日本語化
        format: 'yyyy/mm/dd', // 日付表示をyyyy/mm/ddにフォーマット
        startDate: sd.shipping_date, // 選択可能な開始日付
        endDate: ed.shipping_date, // 選択可能な終了日付
        disabled: false, // 日付を選択させない
        autoclose: true, // 選択後閉じる
        clearBtn: false, // クリアボタン表示
        // datesDisabled: disableArray ,//  選択不可にする日付配列
        // container: '#picker-container',// ピッカーを追加させる一時的な場所
        maxViewMode: 0, // 日時のみ選択可能
        beforeShowDay: function (date) {
            let param;
            let dateStr = formatDate(date);
            let rateNum = checkMap.get(dateStr);

            if (rateNum === '') {
                param = {
                    classes: 'disabled', // -にするCSSのクラス名
                };
            } else if (Number(rateNum) === 100) {
                param = {
                    classes: 'batsu', // ×にするCSSのクラス名
                };
            } else if (Number(rateNum) < 50) {
                param = {
                    classes: 'maru', // ○にするCSSのクラス名
                };
            } else {
                param = {
                    classes: 'sankaku', // △にするCSSのクラス名
                };
            }
            return param;
        },
    });

    // datepickerを表示
    $('#shipping-date').datepicker('show');

    // nextを制御
    $('.datepicker')
        .find('.next')
        .on('click', function (e) {
            //　非活性クラスがある場合次月に遷移しない
            if ($(this).hasClass('disabled')) {
                e.stopImmediatePropagation();
            }
        });
    // prevを制御
    $('.datepicker')
        .find('.prev')
        .on('click', function (e) {
            //　非活性クラスがある場合前月に遷移しない
            if ($(this).hasClass('disabled')) {
                e.stopImmediatePropagation();
            }
        });
}

/**
 * 出荷予定日取得APIから出荷予定日情報を取得しDateTimePickerを表示します。
 */
function dateTimePickerApi() {
    $('#shipping-date').on('click', function (event) {
        // DatatimePickerの表示を抑制
        event.stopImmediatePropagation();

        const url = $(this).data('apiurl');
        if (!url) {
            return;
        }
        const pid = base.getPidValue($(this));

        // bodyにcssを追加
        const body = $('body');
        if (!body.hasClass('product-detail-page')) {
            body.addClass('product-detail-page');
        }

        $.spinner().start();
        $.ajax({
            url,
            method: 'GET',
            data: {
                pid,
            },
        })
            .done(function (data) {
                if (data.success) {
                    dateTimePickerFunc(data);
                    return;
                }
                if (data.redirectUrl) {
                    window.location.href = data.redirectUrl;
                } else if (data.errorMessage) {
                    createErrorNotification(data.errorMessage);
                }
            })
            .fail(function (data) {
                createErrorNotification(data.responseJSON.message);
            })
            .always(function () {
                $.spinner().stop();
            });
    });
}

/**
 * Swiperスクリプト：サムネイル操作
 */
const swiperProductsThumbnail = new Swiper('.swiper_products_thumbnail', {
    breakpoints: {
        // ブレークポイント
        0: {
            // 画面幅0px以上で適用
            slidesPerView: 6,
        },
        768: {
            // 画面幅769px以上で適用
            slidesPerView: 12,
        },
        1200: {
            // 画面幅1200px以上で適用
            slidesPerView: 12,
        },
    },
    allowTouchMove: false,
});

/**
 * Swiperスクリプト：商品スライド
 */
const swiperProducts = new Swiper('.swiper_products', {
    breakpoints: {
        // ブレークポイント
        0: {
            // 画面幅0px以上で適用
            slidesPerView: 1,
        },
        768: {
            // 画面幅769px以上で適用
            slidesPerView: 1,
        },
        1200: {
            // 画面幅1200px以上で適用
            slidesPerView: 1,
        },
    },
    loop: true, // ループさせる
    speed: 1500, // 少しゆっくり(デフォルトは300)
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    thumbs: {
        swiper: swiperProductsThumbnail,
    },
});

/**
 * 購入エリア(SP)を適切な位置に移動する。
 * これは、リモートインクルード('Product-IncludePurchase')が出力した時点では、本来の位置に購入エリア(SP)が存在しないことによる。
 *
 * @returns {void}
 */
function moveProductPurchaseSp() {
    const $bundleFooter = $('.bundle-footer');
    const $bundleFooterRow = $bundleFooter.closest('.row');
    const $productItemContainer = $('.container.product-detail.set-item');
    $bundleFooterRow.insertAfter($productItemContainer);
}

/**
 * eギフトへのアンカー押下時にスクロールする。
 *
 */
function scrollEGift() {
    $('.btn-egift').on('click', function () {
        // エリアの位置情報から画面上部のブランドバー位置を引く
        const elementOffset = $('.egift-anker').offset().top - 40;
        scroll(elementOffset);
    });
}

const exportDetails = $.extend({}, base, detail, {
    quantityChange,
    addToCart: function () {}, // addToCartを共通化。base側の処理がコールされないように処理を無効化。
    clickAssortedProducts,
    dateTimePickerApi,
    moveProductPurchaseSp,
    scrollEGift,
});

module.exports = exportDetails;
